/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-time-event': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 3.75c0-.69-.56-1.25-1.25-1.25h-2.5V1.25H12.5V2.5h-5V1.25H6.25V2.5h-2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h2.5v-1.25h-2.5V3.75h2.5V5H7.5V3.75h5V5h1.25V3.75h2.5V7.5h1.25V3.75zm-4.375 5.625l1.594 3.088 3.406.493-2.5 2.4.619 3.394-3.05-1.6L10 18.75l.625-3.394-2.5-2.4 3.5-.493 1.5-3.088z"/>'
  }
})
